export const browserTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

// <input type="datetime-local"> value (local wall time) → ISO string in UTC
export const localInputToIso = value => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
};

// ISO → datetime-local input value in the browser timezone
export const isoToLocalInput = iso => {
  if (!iso) return '';
  const date = new Date(iso);
  const pad = n => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

// Prefilled with the current time just for convenience; the user picks the real value.
export const defaultScheduleValue = () => {
  const date = new Date();
  date.setSeconds(0, 0);
  return isoToLocalInput(date.toISOString());
};

export const formatScheduledAt = (iso, locale) =>
  new Date(iso).toLocaleString((locale || 'en').replace('_', '-'), {
    dateStyle: 'short',
    timeStyle: 'short',
  });

// Locale-aware clock: the browser locale would force 12h (09:59 PM) on a pt-BR UI.
export const formatTime = (iso, locale) =>
  new Date(iso).toLocaleTimeString((locale || 'en').replace('_', '-'), {
    hour: '2-digit',
    minute: '2-digit',
  });

// Which service-window warning the selected inbox needs. WhatsApp has templates as the
// escape hatch; Instagram/Messenger/TikTok have a window but no template — a scheduled
// free-form message simply fails if the contact has not interacted recently.
export const windowHintKey = inbox => {
  switch (inbox?.channel_type) {
    case 'Channel::Whatsapp':
      return 'WINDOW_HINT';
    case 'Channel::Instagram':
    case 'Channel::FacebookPage':
      return 'WINDOW_HINT_META';
    case 'Channel::Tiktok':
      return 'WINDOW_HINT_TIKTOK';
    default:
      return null;
  }
};
